import React, { Component } from 'react';
import { Form, Row, Col, Button, Modal } from 'react-bootstrap';
import { ITermsAndConditionListingProps } from '../../types/propTypes';
import { WithTranslation, withTranslation } from 'react-i18next';
import { ITermsAndConditionListingState } from '../../types/stateTypes';
import LoginService from '../../services/login/loginApi-service';
import StandardResponse from '../../models/standard-response';
import { ITermsCondtionData, IUserData } from '../../models/login';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
import { AppState } from '../../store/state/app.state';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import images from '../../assets/images';
import { companyNameReplace } from '../../utils';
export class AcceptTermsAndCondition extends Component<
    ITermsAndConditionListingProps & WithTranslation,
    ITermsAndConditionListingState
> {
    maxHeight: number = 350;
    loginService: LoginService;
    constructor(props) {
        super(props);
        this.state = {
            TermsConditionList: [],
            requiredTermsAndCondition: [],
            selectedTermsAndCondition: [],
            isReachedToBottom: false,
            model: {
                body: null,
                header: '',
                showModel: false,
                id: null,
            },
        };
        this.loginService = new LoginService();
    }
    async componentDidMount() {
        await this.getTermsConditionListing();
    }
    trackScrolling = () => {
        const wrappedElement = document.getElementById('terms_condition');
        if (wrappedElement !== null && this.isBottom(wrappedElement)) {
            this.setState({ isReachedToBottom: true });
        }
    };
    isBottom(el) {
        const height = document.getElementsByClassName('modal-content')[0].clientHeight;
        return el.scrollTop + height >= el.scrollHeight;
    }
    getTermsConditionListing = async () => {
        let requiredTermsAndConditionIds = [];
        let TermsConditionList: Array<any> = [];
        await this.loginService
            .getTermsAndConditionListing()
            .then(async (res: StandardResponse<Array<ITermsCondtionData>>) => {
                if (this.props.userData.has_saved_terms) {
                    if (_.isArray(res.Data)) {
                        TermsConditionList = res.Data.filter(
                            (x) => x.accepted === null || (x.mandatory === true && x.accepted === false),
                        );
                    }
                } else {
                    TermsConditionList = res.Data;
                }
                if (_.isArray(TermsConditionList)) {
                    const requiredTermsCondition = TermsConditionList.filter((x) => x.mandatory === true);
                    if (_.isArray(requiredTermsCondition)) {
                        requiredTermsCondition.forEach((data) => {
                            requiredTermsAndConditionIds.push(data.id);
                        });
                    }
                }

                this.setState({
                    TermsConditionList,
                    requiredTermsAndCondition: requiredTermsAndConditionIds,
                });
            })
            .catch((m) => {
                toast.error(m.toString());
            });
    };

    handleSubmit = async () => {
        let acceptedAllTermsCondition = true;
        this.state.requiredTermsAndCondition.forEach((data) => {
            if (!this.state.selectedTermsAndCondition.includes(data)) {
                acceptedAllTermsCondition = false;
            }
        });

        if (acceptedAllTermsCondition) {
            const terms_conditions = [];
            this.state.TermsConditionList.forEach((data) => {
                terms_conditions.push({
                    id: data.id,
                    accepted: this.state.selectedTermsAndCondition.includes(data.id),
                });
            });
            const input = { terms_conditions };

            await this.loginService
                .saveTermsAndCondition(input)
                .then(async (res: StandardResponse<number>) => {
                    await this.loginService
                        .userDetails()
                        .then((userDetail: StandardResponse<IUserData>) => {
                            this.props.userDetail(userDetail);
                            this.props.setCurrencyDetails(userDetail?.Data?.currency_details);
                            this.props.history.push('/');
                        })
                        .catch((m) => {
                            if (
                                m.response &&
                                m.response.data &&
                                m.response.data.message &&
                                m.response.data.message.includes('Organisation is deleted')
                            ) {
                                toast.error(m.response.data.message);
                            } else if (m && m.includes('Organisation is deleted')) {
                                toast.error(m.toString());
                            } else {
                                toast.error(this.props.t('login.toast.error'));
                            }
                            this.props.logout();
                        });
                })
                .catch((m) => {
                    if (m.response && m.response.message) {
                        toast.error(m.response.message);
                    } else {
                        toast.error(m.toString());
                    }
                });
        } else {
            toast.error(this.props.t('termsAndConditionListing.errors.acceptTermCondition'));
        }
    };

    acceptTermsCondition = (id: number) => {
        let selectedTermsAndCondition = this.state.selectedTermsAndCondition;
        selectedTermsAndCondition.push(id);
        this.setState({
            selectedTermsAndCondition,
            model: {
                body: '',
                header: '',
                id: null,
                showModel: false,
            },
            isReachedToBottom: false,
        });
    };
    handleModel = (body: string, header: string, showModel: boolean, id: number) => {
        this.setState(
            {
                model: {
                    body,
                    header,
                    showModel,
                    id,
                },
                isReachedToBottom: false,
            },
            () => {
                if (showModel) {
                    if (document.getElementById('terms_condition').scrollHeight <= this.maxHeight) {
                        this.setState({
                            isReachedToBottom: true,
                        });
                    }
                }
            },
        );
    };
    handleCheckChange = (data: ITermsCondtionData) => {
        if (this.state.selectedTermsAndCondition.includes(data.id)) {
            var array = this.state.selectedTermsAndCondition;
            var index = array.indexOf(data.id);
            if (index !== -1) {
                array.splice(index, 1);
                this.setState({ selectedTermsAndCondition: array });
            }
        } else {
            this.handleModel(data.content, data.name, true, data.id);
        }
    };

    render() {
        const { t } = this.props;
        return (
            <>
                <Helmet>
                    <title>{companyNameReplace(t('termsAndConditionListing.title'))} </title>
                </Helmet>
                <div className="login-page p-0 no-gutters container-fluid clearfix">
                    <Row className="row no-gutters min-h-100 align-items-center">
                        <Col>
                            <div className="login-outer">
                                <div className="login-block">
                                    <a className="logo" href="/" title={t('login.button.instavolt')}>
                                        <img
                                            className="d-block"
                                            src={images.adminLogoPNG}
                                            alt={t('login.button.instavolt')}
                                        />
                                    </a>
                                    <h1 className="title">{companyNameReplace(t('login.loginForm.header'))}</h1>

                                    {this.props.userData.has_saved_terms ? (
                                        <div className="form-group mb-0">
                                            <p>{t('termsAndConditionListing.label.reviewUpdatedCondition')}</p>
                                        </div>
                                    ) : (
                                        <div className="form-group mb-0">
                                            <p className="text-center">
                                                {t('termsAndConditionListing.label.termsAndConditions')}
                                            </p>
                                        </div>
                                    )}

                                    <form className="tac-form form-secondary" autoComplete="off">
                                        {this.state.TermsConditionList.length > 0 &&
                                            this.state.TermsConditionList.map(
                                                (data: ITermsCondtionData, index: number) => {
                                                    return (
                                                        <Form.Group key={index} className="form-group">
                                                            <div className="custom-control custom-checkbox custom-control-inline">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id={`tc${data.id}`}
                                                                    name="termsCondition"
                                                                    checked={this.state.selectedTermsAndCondition.includes(
                                                                        data.id,
                                                                    )}
                                                                    onChange={() => this.handleCheckChange(data)}
                                                                />
                                                                <label
                                                                    className="custom-control-label pb-0"
                                                                    htmlFor={`tc${data.id}`}
                                                                >
                                                                    {t(
                                                                        'termsAndConditionListing.label.iAggreeToTermsCondition',
                                                                    )}
                                                                    <span
                                                                        onClick={() =>
                                                                            this.handleModel(
                                                                                data.content,
                                                                                data.name,
                                                                                true,
                                                                                data.id,
                                                                            )
                                                                        }
                                                                        className="term-and-condition"
                                                                    >
                                                                        {`${data.name} ${data.mandatory ? '*' : ''}`}
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        </Form.Group>
                                                    );
                                                },
                                            )}

                                        <p>
                                            <span className="themeColor">
                                                {t('termsAndConditionListing.label.note')}
                                            </span>
                                            {t('termsAndConditionListing.noteDetails')}
                                        </p>
                                        <Form.Group className="form-group">
                                            <Button onClick={this.handleSubmit} className="w-100">
                                                <span>{t('termsAndConditionListing.button.next')}</span>
                                            </Button>
                                        </Form.Group>
                                    </form>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <Modal show={this.state.model.showModel} onHide={() => this.handleModel('', '', null, null)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.model.header}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div
                            onScroll={this.trackScrolling}
                            id="terms_condition"
                            style={{ maxHeight: this.maxHeight, overflow: 'auto' }}
                            dangerouslySetInnerHTML={{
                                __html: this.state.model.body,
                            }}
                        ></div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            disabled={!this.state.isReachedToBottom}
                            className="btn btn-primary"
                            onClick={() => {
                                this.acceptTermsCondition(this.state.model.id);
                            }}
                            title={t('termsAndConditionListing.button.accept')}
                        >
                            <span>{t('termsAndConditionListing.button.accept')}</span>
                        </Button>
                        <Button
                            className="btn btn-secondary"
                            onClick={() => this.handleModel('', '', false, null)}
                            title={t('termsAndConditionListing.button.cancel')}
                        >
                            <span>{t('termsAndConditionListing.button.cancel')}</span>
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}
const mapStateToProps = (state: AppState) => ({
    userData: state.UserData,
});
export default connect(mapStateToProps, null)(withTranslation()(AcceptTermsAndCondition));
